import React from "react";
import "../Style/documentationLibrary.css"; // Create this CSS file if needed, similar to privacyPolicy.css

const DocumentationLibraryBanner = () => {
  return (
    <div className="flex justify-center items-center text-white z-50 privacy-banner pt-[140px] pb-[85px]">
      <h1 className="text-white text-[28px] lg:text-[38px] font-semibold leading-[92px]">
        Documentation Library
      </h1>
    </div>
  );
};

export default DocumentationLibraryBanner;
